import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { EMPLOYEE_API } from "../apiRoutes";

const mutateUpdateEmployeeAffiliation = async ({
  userId,
  data,
}: {
  userId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${EMPLOYEE_API}/community/role/${userId}`, data);
};

const useUpdateEmployeeAffiliationMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      userId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateEmployeeAffiliation,
    ...queryParams,
  });

export default useUpdateEmployeeAffiliationMutation;
